import { mountQuill } from "@quill/widget";
import { TernlightPlanner, type LocalModel } from "./local-planner.js";

// The reservation form handles submit locally so the demo is self-contained.
const form = document.getElementById("reservation") as HTMLFormElement;
const confirmation = document.querySelector<HTMLDivElement>('[data-testid="confirmation"]')!;

form.addEventListener("submit", (e) => {
  e.preventDefault();
  const name = (document.getElementById("name") as HTMLInputElement).value || "your party";
  const party = (document.getElementById("party") as HTMLSelectElement).selectedOptions[0]?.textContent ?? "";
  const date = (document.getElementById("date") as HTMLInputElement).value;
  confirmation.textContent = `✓ Reservation confirmed for ${name}${party ? ` — ${party}` : ""}${date ? ` on ${date}` : ""}.`;
  confirmation.classList.add("show");
});

const model = document.querySelector<HTMLSelectElement>('[data-testid="model-selector"]')!;
const modelStatus = document.querySelector<HTMLElement>('[data-testid="model-status"]')!;
model.addEventListener("change", () => {
  modelStatus.textContent = model.value === "webllm"
    ? "WebLLM uses WebGPU; first use downloads and caches the model locally"
    : `${model.selectedOptions[0]?.textContent} runs locally in this tab`;
});

const planner = new TernlightPlanner(
  () => model.value as LocalModel,
  (status) => { modelStatus.textContent = status; },
);

const quill = mountQuill({
  planner,
  theme: "auto",
  position: "bottom-right",
  voice: true,
  greeting: "Tell me who, when, and how many. You can reply here if I need more details.",
});

// The demo button opens Quill and kicks off the task, showing the full pipeline.
document.querySelector('[data-testid="run-demo"]')!.addEventListener("click", () => {
  quill.open();
  const date = new Date(Date.now() + 86_400_000).toISOString().slice(0, 10);
  void quill.run(`Book a table for Ada Lovelace (ada@example.com), 2 guests on ${date}, with a window seat.`);
});
